import { render } from "./app-pagination.vue?vue&type=template&id=780dd2cb"
import script from "./app-pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./app-pagination.vue?vue&type=script&setup=true&lang=js"

import "./app-pagination.vue?vue&type=style&index=0&id=780dd2cb&lang=css"
const cssModules = {}
import style1 from "./app-pagination.vue?vue&type=style&index=1&id=780dd2cb&module=true&lang=css"
cssModules["$style"] = style1
if (module.hot) {
  module.hot.accept("./app-pagination.vue?vue&type=style&index=1&id=780dd2cb&module=true&lang=css", () => {
    cssModules["$style"] = style1
    __VUE_HMR_RUNTIME__.rerender("780dd2cb")
  })
}

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__file',"resources/js/common/shared/components/app-pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "780dd2cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('780dd2cb', __exports__)) {
    api.reload('780dd2cb', __exports__)
  }
  
  module.hot.accept("./app-pagination.vue?vue&type=template&id=780dd2cb", () => {
    api.rerender('780dd2cb', render)
  })

}


export default __exports__